export default "__VITE_ASSET__ba6f331c__"